<div class="h-100 d-flex justify-content-center align-items-center">
  <div class="pt-3 pt-sm-0 w-75 targets-table">
    <div
      class="table-header d-flex flex-row align-items-center p-2"
      [ngClass]="makeColumnsEqualWidth ? 'justify-content-between' : 'justify-content-start'"
    >
      <div class="col-1" *ngIf="!makeColumnsEqualWidth"></div>

      <div class="col-2" [ngClass]="{ 'ps-3': makeColumnsEqualWidth }">
        {{ 'Band' | translate }}
      </div>

      <div [ngClass]="makeColumnsEqualWidth ? 'col-2' : 'col-5'">
        {{ 'Revenue' | translate }}
      </div>

      <div [ngClass]="makeColumnsEqualWidth ? 'col-2' : 'col-5'">
        {{ 'Rebate' | translate }}
      </div>
    </div>

    <div class="table-body">
      <div
        class="table-row d-flex flex-row align-items-center p-2"
        [ngClass]="makeColumnsEqualWidth ? 'justify-content-between' : 'justify-content-start'"
        *ngFor="let option of salesTargetOptions"
      >
        <div class="col-1" *ngIf="!makeColumnsEqualWidth">
          <fa-icon
            [icon]="['fas', 'circle-check']"
            [size]="'lg'"
            *ngIf="showCompletedCheck && rebateSummary && rebateSummary.qtrRevLocalCurrency >= option.salesTarget"
          ></fa-icon>
        </div>

        <div class="col-2" [ngClass]="{ 'ps-3': makeColumnsEqualWidth }">
          {{ option.band }}
        </div>

        <div [ngClass]="makeColumnsEqualWidth ? 'col-2' : 'col-5'">
          {{ option.currency.symbol }}{{ option.salesTarget | number }}
        </div>

        <div [ngClass]="makeColumnsEqualWidth ? 'col-2' : 'col-5'">
          {{ option.currency.symbol }}{{ option.entryRebate | number }}
        </div>
      </div>
    </div>
  </div>
</div>
